import React from 'react';
import styled from 'styled-components';
import Typography from '@mui/material/Typography';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import MenuItem from '@mui/material/MenuItem';

export const SettingHeader = styled(Typography)`
    color: #73808d;
    font-family: HelveticaNeue, Helvetica, sans-serif;
    font-size: 11px;
    letter-spacing: 1.5px;
    padding: 8px 12px 6px;
    text-transform: uppercase;
`;

export const SettingSubHeader = styled(Typography)`
    background-color: rgb(231, 235, 238);
    color: rgb(109, 118, 126);
    font-family: HelveticaNeue, Helvetica, sans-serif;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.5px;
    padding: 8px 12px 6px;
    text-transform: uppercase;
`;

export const AccordionSetting = styled(Accordion)`
    width: 100%;
    border: none;
    box-shadow: none;
    &:hover {
        background-color: rgba(0, 0, 0, 0.04);
    }
`;

export const AccordionSettingSummary = styled(AccordionSummary)`
    justify-content: space-between;
    align-content: space-between;
    padding: 12px 12px;
    min-height: 16px;
    max-height: 24px;
    line-height: 1px;
    margin: 3px 0;
    &.Mui-expanded {
        min-height: 16px;
        max-height: 24px;
    }
`;

export const AccordionSummaryValue = styled.div`
    color: #3498db;
    font-size: 12px;
    font-weight: 700;
    position: absolute;
    right: 36px;
    text-transform: capitalize;
`;

export const AccordionSettingDetail = styled(AccordionDetails)`
    border: none;
    margin: 0;
    padding: 0;
    & > li {
        background-color: rgba(244, 246, 248, 0.7);
        border: 1px solid #e5e5e5;
        font-size: 8px;
    }
`;

export const CustomMenuItem = styled(MenuItem)`
    padding: 0;
`;

export const SettingLabel = styled.label`
    color: #494949;
    font-weight: 700;
    font-size: 12px;
`;
interface CheckboxProps {
    id?: string;
    displayName: string;
    checked: boolean;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}
export const SettingCheckbox: React.FC<CheckboxProps> = props => {
    const { id, displayName, checked, onChange } = props;
    const elementId = id ? id : displayName + 'Checkbox';
    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'flex-start',
                gap: '4px',
            }}
        >
            <input
                type="checkbox"
                id={elementId}
                checked={checked}
                onChange={onChange}
            />
            <SettingLabel htmlFor={elementId}>{displayName}</SettingLabel>
        </div>
    );
};
